export default "__VITE_ASSET__Cat$2yRq__"